module.exports = new __parcel__URL__("task-board-with-people.e468116d.svg").toString();